export default __webpack_public_path__ + "static/media/icn-special.2fab8316.svg";